import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';
import { AppState } from '../store/app.state';
import {
  selectAuthInitialized,
  selectIsAdmin,
} from '../store/user/user.selectors';

export const adminGuard = () => {
  const store = inject(Store<AppState>);
  const navigationService = inject(NavigationService);

  return combineLatest([
    store.select(selectIsAdmin),
    store.select(selectAuthInitialized),
  ]).pipe(
    filter(([_, authInitialized]) => authInitialized),
    take(1),
    map(([isAdmin]) => {
      if (isAdmin) {
        return true;
      }

      navigationService.navigateToHome();
      return false;
    })
  );
};
